// Carries a plan choice from the public pricing page through signup.
//
// The pricing CTAs link to /register?plan=starter, but signup detours via
// email-OTP verification (which navigates with router state, not query
// params) before landing in the app. sessionStorage bridges that gap: it
// survives the redirects, dies with the tab, and never leaks between
// users the way localStorage would on a shared machine.

const KEY = 'stovalt.intended_plan'

// Only ever store a plan we recognise - this value ends up driving a
// checkout call, so it should not be free-form from the query string.
const KNOWN_PLANS = ['starter', 'pro']

export function rememberIntendedPlan(plan) {
  if (!plan || !KNOWN_PLANS.includes(plan)) return
  try {
    sessionStorage.setItem(KEY, plan)
  } catch {
    // Private mode / storage disabled - the operator just picks the plan
    // again in Settings. Not worth surfacing.
  }
}

export function readIntendedPlan() {
  try {
    const plan = sessionStorage.getItem(KEY)
    return KNOWN_PLANS.includes(plan) ? plan : null
  } catch {
    return null
  }
}

export function clearIntendedPlan() {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing to do.
  }
}
